<template>
  <popup :title="`מצטערים, המערכת לא תומכת כרגע ב${source.displayName}...`"
    :close-action="popupClosed"
    :buttons="[
  {
    title: 'זה החשבון העיקרי שלי',
    subtitle: 'תעדכנו אותי כשתתמכו',
    action: primaryBankSelected,
    variant: 'primary',
  },
  {
    title: 'זה לא החשבון העיקרי',
    subtitle: 'אני רוצה להמשיך בלעדיו',
    action: continueWithoutSelected,
    variant: 'primary',
  },
]"/>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../../Segment';
import router from '../../../../router';
import CommunicationStateApi from '../../../../api/CommunicationStateApi';

export default {
  name: 'UnsupportedBanksDecisionPopup',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Popup: BaseUI.Popup,
  },
  props: ['source'],
  mounted() {
    Segment.trackUserGot('UnsupportedBanksPopupEntered', { sourceName: this.source.sourceName });
  },
  methods: {
    primaryBankSelected() {
      Segment.trackUserInteraction('PrimaryBankClicked', {
        sourceName: this.source.sourceName,
      });
      CommunicationStateApi.disableBoti(`Unsupported: ${this.source.waitingListName}`);
      this.closeModal();
      router.push({ path: '/unsupported-banks', query: { sourceName: this.source.sourceName, sourceDisplayName: this.source.displayName } });
    },
    continueWithoutSelected() {
      Segment.trackUserInteraction('ContinueWithoutBankClicked', {
        sourceName: this.source.sourceName,
      });
      this.closeModal();
    },
    popupClosed() {
      Segment.trackUserInteraction('UnsupportedBanksDecisionClosed', {
        sourceName: this.source.sourceName,
      });
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/unsupported-banks/UnsupportedBanksDecisionPopup.vue